export default "__VITE_ASSET__BnPoWGgR__"